package com.patronat.top.dto

import kotlinx.serialization.Serializable


@Serializable
data class GetUsersRequest(
    val page: Int,
    val pageSize: Int,
    val query: String?,
    val roles: List<UserRole>?,
    val statuses: List<UserStatus>?,
    val ownerId: String? = null
)

@Serializable
data class CreateUserRequest(
    val phone: String,
    val email: String?,
    val firstName: String,
    val lastName: String,
    val role: UserRole,
    val avatarUrl: String? = null,
    val avatarMediaId: String? = null,
)

@Serializable
data class UpdateUserRequest(
    val phone: String,
    val email: String?,
    val firstName: String,
    val lastName: String,
    val status: UserStatus,
    val avatarUrl: String? = null,
    val avatarMediaId: String? = null,
)

@Serializable
data class UpdateUserStatusRequest(
    val newStatus: UserStatus
)

@Serializable
data class UpdateCurrentUserRequest(
    val phone: String = "",
    val email: String? = null,
    val firstName: String,
    val lastName: String,
    val avatarUrl: String? = null,
    val avatarMediaId: String? = null
)

@Serializable
data class ContactSupportRequest(
    val subject: String,
    val description: String
)

@Serializable
data class DeleteCurrentUserRequest(
    val email: String? = null,
    val reason: String
)
